import { logDispatcher } from 'src/app/core/decorators/state.decorators';
import { MassiveNotification, MassiveResponse } from '../../models/massive.model';

export namespace MassiveActions {
  @logDispatcher
  export class GetMassiveNotification {
    static readonly type = '[MassiveActions] GetMassiveNotification';
    constructor() {}
  }

  @logDispatcher
  export class GetMassiveResponse {
    static readonly type = '[MassiveActions] GetMassiveResponse';
    constructor() {}
  }

  @logDispatcher
  export class SetMassiveResponse {
    static readonly type = '[MassiveActions] SetMassiveResponse';
    constructor(public massiveResponse: MassiveResponse) {}
  }

  @logDispatcher
  export class UpdateMassiveNotification {
    static readonly type = '[MassiveAction] UpdateMassiveNotification';
    constructor(public massiveNotification: MassiveNotification) {}
  }

  @logDispatcher
  export class SetDefaultState {
    static readonly type = '[MassiveActions] SetDefaultState';
    constructor() {}
  }
}